import * as actionTypes from "./EmployeeAdvanceType";
const INITIAL_STATE = {
    prjList: [],
    locationList: [],
    costcenterList: [],
    empAdvList: [],
    empCustomerList: [],
    empAdvNumberList: [],
    advanceFilterList: [],
    employeeAdvList: [],
    employeeAdvance: [],
    attachmentList: [],
    employeeAdvanceHeaderFilterData: []
};

const EmployeeAdvanceReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETPRJLIST:
            return {
                ...state,
                prjList: action.payload.list,
            };
        case actionTypes.SETLOCATIONLIST:
            return {
                ...state,
                locationList: action.payload.list,
            };
        case actionTypes.SETCOSTCENTERLIST:
            return {
                ...state,
                costcenterList: action.payload.list,
            };
        case actionTypes.SETEMPADVLIST:
            return {
                ...state,
                empAdvList: action.payload.list,
            };
        case actionTypes.SETEMPADVCUSTLIST:
            return {
                ...state,
                empCustomerList: action.payload.list,
            };
        case actionTypes.SETEMPADVNUMBERLIST:
            return {
                ...state,
                empAdvNumberList: action.payload.list,
            };
        case actionTypes.SETEMPADVFIELDLIST:
            return {
                ...state,
                advanceFilterList: action.payload.list
            };
        case actionTypes.SETEMPADVFILTERLIST:
            return {
                ...state,
                empAdvList: action.payload.list,
            };
        case actionTypes.SETEMPADVEDIT:
            return {
                ...state,
                employeeAdvance: action.payload.data
            }
        case actionTypes.SETEMPATTACHMENTLIST:
            return {
                ...state,
                attachmentList: action.payload.list
            };
        case actionTypes.SETEMPLOYEEADVANCEHEADERFILTERDATA:
            return {
                ...state,
                employeeAdvanceHeaderFilterData: { ...action.payload }
            };
        default:
            return state;
    }
}

export default EmployeeAdvanceReducer;